import { API_URL } from '@/lib/consts';

import type { FeedbackSubmission, FeedbackSubmitResponse } from './ontology/types';

/** Submits authenticated feedback to the protected backend endpoint. */
export async function submitFeedback(record: FeedbackSubmission): Promise<FeedbackSubmitResponse> {
  const response = await fetch(`${API_URL}/feedback/submit`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(record),
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  const body: FeedbackSubmitResponse = await response.json();

  // TODO(2): currently unreachable — backend only returns 'success'; becomes
  // meaningful once the backend reports in-body failure states (see
  // rust/server/src/api/feedback.rs SubmitFeedbackStatus).
  if (body.status !== 'success') {
    throw new Error(`Unexpected feedback submit status: ${body.status}`);
  }

  return body;
}
